/** Mirrors platform `users.parenting_status` / PATCH `parentingStatus`. */
export enum ParentingStatus {
  ASPIRING_PARENT = "ASPIRING_PARENT",
  DOG_PARENT = "DOG_PARENT",
}

/** Mirrors platform `users.user_interests` / PATCH `userInterests`. */
export enum UserInterest {
  MY_DOG_NEEDS_REGULAR_WALKS = "MY_DOG_NEEDS_REGULAR_WALKS",
  GROOMING_HARD_TO_MANAGE = "GROOMING_HARD_TO_MANAGE",
  WANT_TO_FEED_BETTER_MEALS = "WANT_TO_FEED_BETTER_MEALS",
  WANT_TO_TRAIN_MY_DOG = "WANT_TO_TRAIN_MY_DOG",
  WANT_TO_BE_PART_OF_A_COMMUNITY = "WANT_TO_BE_PART_OF_A_COMMUNITY",
  WANT_TO_LEARN_MORE_ABOUT_DOG_PARENTING = "WANT_TO_LEARN_MORE_ABOUT_DOG_PARENTING",
  SOMETIMES_NEED_HELP_OR_ADVICE = "SOMETIMES_NEED_HELP_OR_ADVICE",
}
